import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Menu, X, ShieldCheck } from "lucide-react";

export default function Navbar() {
  const { user, logout, promptLogin } = useAuth();
  const [open, setOpen] = React.useState(false);

  const navItems = [
    { to: "/properties", label: "Buy / Rent" },
    { to: "/sell", label: "Sell / List Property" },
    { to: "/legal", label: "Legal" },
    { to: "/about", label: "About" },
  ];

  return (
    <header className="sticky top-0 z-50 glass border-b border-border/60">
      <div className="container-tharlo flex items-center justify-between h-16 lg:h-20">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-ink flex items-center justify-center">
            <ShieldCheck className="w-4 h-4 text-gold" />
          </div>
          <div className="leading-none">
            <div className="font-display text-xl tracking-tight text-ink">Tharlo</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors hover:text-ink ${isActive ? "text-ink" : "text-foreground/70"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="navbar-admin-link" className="text-sm font-medium text-ink hover:text-gold">Admin</Link>
              )}
              {user.user_type === "buyer" ? (
                <Link to="/dashboard" data-testid="navbar-dashboard-link" className="text-sm font-medium text-ink hover:text-gold">My Dashboard</Link>
              ) : user.user_type === "seller" ? (
                <Link to="/broker" data-testid="navbar-broker-link" className="text-sm font-medium text-ink hover:text-gold">My Listings</Link>
              ) : (
                <>
                  <Link to="/dashboard" data-testid="navbar-dashboard-link" className="text-sm font-medium text-ink hover:text-gold">Buyer</Link>
                  <Link to="/broker" data-testid="navbar-broker-link" className="text-sm font-medium text-ink hover:text-gold">Seller</Link>
                </>
              )}
              <span className="text-sm text-foreground/70" data-testid="navbar-user-name">{user.name}</span>
              <button onClick={logout} data-testid="navbar-logout-btn" className="text-sm text-foreground/70 hover:text-ink">Logout</button>
            </>
          ) : (
            <button onClick={promptLogin} data-testid="navbar-login-btn" className="text-sm font-semibold text-ink hover:text-gold">Sign in</button>
          )}
        <Link to="/sell" data-testid="navbar-cta-sell" className="btn-gold !py-2.5 !px-5">List Property</Link>
        </div>

        <button onClick={() => setOpen(!open)} className="lg:hidden p-2" data-testid="navbar-menu-toggle">
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-white">
          <div className="container-tharlo py-4 flex flex-col gap-3">
            {navItems.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="py-2 text-sm font-medium">{n.label}</Link>
            ))}
            {user ? (
              <>
                {user.role === "admin" && <Link to="/admin" onClick={()=>setOpen(false)} className="py-2 text-sm font-medium">Admin</Link>}
                {user.user_type === "buyer" ? (
                  <Link to="/dashboard" onClick={()=>setOpen(false)} className="py-2 text-sm font-medium">My Dashboard</Link>
                ) : user.user_type === "seller" ? (
                  <Link to="/broker" onClick={()=>setOpen(false)} className="py-2 text-sm font-medium">My Listings</Link>
                ) : (
                  <>
                    <Link to="/dashboard" onClick={()=>setOpen(false)} className="py-2 text-sm font-medium">Buyer Dashboard</Link>
                    <Link to="/broker" onClick={()=>setOpen(false)} className="py-2 text-sm font-medium">Seller Dashboard</Link>
                  </>
                )}
                <button onClick={logout} className="text-left py-2 text-sm">Logout</button>
              </>
            ) : (
              <button onClick={() => { promptLogin(); setOpen(false); }} className="text-left py-2 text-sm font-semibold">Sign in</button>
            )}
            <Link to="/sell" onClick={()=>setOpen(false)} className="btn-gold mt-2">List Property</Link>
          </div>
        </div>
      )}
    </header>
  );
}
